import { DropdownFullItemProps } from 'interfaces'

export const optionSeletVisibility = [
	{
		id: 1,
		name: 'Show organization',
		value: 'true'
	},
	{
		id: 2,
		name: 'Hide organization',
		value: 'false'
	}
] as DropdownFullItemProps[]

export const optionSeletCSV = [
	{
		id: 1,
		name: 'CSV Import or Update is disabled',
		value: 'false'
	},
	{
		id: 2,
		name: 'CSV Import or Update is enabled',
		value: 'true'
	}
] as DropdownFullItemProps[]

export const optionOTPHasRequired = [
	{
		id: 1,
		name: 'OTP is NOT required',
		value: 'false'
	},
	{
		id: 2,
		name: 'OTP is required',
		value: 'true'
	}
] as DropdownFullItemProps[]

export const organizationResource = [
	{
		id: 1,
		name: 'Enable Advance Resources',
		value: 'true'
	},
	{
		id: 2,
		name: 'Disable Advance Resources',
		value: 'false'
	}
] as DropdownFullItemProps[]

export const optionsCalendarView = [
	{
		id: 1,
		name: 'Calendar View Is Hidden',
		value: 'false'
	},
	{
		id: 2,
		name: 'Calendar View is Visible',
		value: 'true'
	}
] as unknown as DropdownFullItemProps[]

export const optionMyNetwork = [
	{
		id: 1,
		name: 'My Network is disabled',
		value: 'false'
	},
	{
		id: 2,
		name: 'My Network is enabled',
		value: 'true'
	}
] as unknown as DropdownFullItemProps[]
